// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2tLQZ","vLegacy":"SelectSecondary_vLegacy__2SzE_","error":"SelectSecondary_error__1wPuq","disabled":"SelectSecondary_disabled__3XBAr"};